import { GDFCustomRecord } from '../../../gdf/type';

export default function CustomDrawTooltip({ record }: { record: GDFCustomRecord }) {
    return (
        <div>
            {record.tipText.filter(Boolean).map((x, i) => (
                <div key={i}>{x}</div>
            ))}
        </div>
    );
}
